import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Table, TableKeyExtractor } from '@dreryk/react-components';

import { TABLE_PAGE_SIZE } from '../shared/constants';

import { useMedicalImagingTableColumns, useMedicalImagingTableDataConfiguration } from './MedicalImagingTable.hooks';

const keyExtractor: TableKeyExtractor<MedicalImaging> = (bean) => bean.medicalInformation.id;

type MedicalImagingTableProps = {
   readonly patientId: number;
   readonly highlightedEntryId?: number;
};

export const MedicalImagingTable = (props: MedicalImagingTableProps): JSX.Element => {
   const dataConfiguration = useMedicalImagingTableDataConfiguration(props.patientId);
   const columns = useMedicalImagingTableColumns(dataConfiguration.refetch);

   return (
      <Table
         testId={'medicalImagingTable'}
         columns={columns}
         dataConfiguration={dataConfiguration}
         pageSize={TABLE_PAGE_SIZE}
         keyExtractor={keyExtractor}
         highlightedRowKey={props.highlightedEntryId}
      />
   );
};
